import React, { useState, lazy } from 'react';
import PropTypes from 'prop-types';
import RenderComponent from './RenderComponent';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const Filters = ({ hasApiStatus, callback, history, fleetCompanyList, filterList, handleReset, values, setInitialValues }) => {
  const [validationError, setValidationError] = useState('');

  return (
    <>
      <Form
        type="server"
        direction="row"
        initialValues={{ ...values }}
        className="CSAForms"
        RenderComponent={RenderComponent}
        handleOnSubmit={(fields) => {
          setValidationError('');
          const finalData = { ...fields, companyId: fields.companyId?.value };
          if (fields.companyId?.value || fields.unit_id) {
            Object.keys(finalData).forEach((key) => !finalData[key] && delete finalData[key]);
            filterList(finalData);
          } else {
            setValidationError('Please select atleast one filter');
          }
        }}
        handleOnCancel={(fields) => {
          handleReset();
          setInitialValues({
            companyId: null,
            unit_id: null,
          });
          setValidationError('');
        }}
        customProps={{
          history,
          callback,
          hasApiStatus,
          validationError,
          fleetCompanyList,
          setInitialValues,
        }}
      />
    </>
  );
};

Filters.propTypes = {
  callback: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default Filters;
